import { render, staticRenderFns } from "./UnitInformationRemoveBackground.vue?vue&type=template&id=a05c1150&scoped=true&lang=pug&"
import script from "./UnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
export * from "./UnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInformationRemoveBackground.vue?vue&type=style&index=0&id=a05c1150&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c1150",
  null
  
)

export default component.exports